//
//
//
//

import { mapGetters } from "vuex";

export default {
  name: "MatrixSelections",
  props: ["id"],
  computed: {
    ...mapGetters(["filters"]),
    selected() {
      if (this.filters[this.id]) {
        let keys = Object.keys(this.filters[this.id]);

        if (keys.length > 3) return `${keys.length} filters selected`;
        return keys.join(", ");
      }
      return false;
    }
  }
};
